import isNil from "lodash/isNil";
import { useQuery } from "urql";

import { GetClikGrantedBondDetailsDocument } from "../../../../graphql/generated.ts";

interface Props {
  id: number | string | null | undefined;
}

export const useClikGrantedDetailsOfBonds = ({ id }: Props) => {
  return useQuery({
    query: GetClikGrantedBondDetailsDocument,
    variables: { id: Number(id) },
    pause: isNil(id),
  });
};
